
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-iv-test-series",
      function () {
        return require("private-next-pages/tnpsc-group-iv-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-iv-test-series"])
      });
    }
  